const TITLES = /^(prof|professor|dr|mr|mrs|ms|miss|sir|assoc|asst|assist|associate|assistant|engr|eng)\.?$/i;

export const getInitials = (name) => {
  const words = (name || "").split(/\s+/).filter((w) => w && !TITLES.test(w.replace(/,$/, "")));
  if (!words.length) return "?";
  const picked = words.length > 1 ? [words[0], words[words.length - 1]] : [words[0]];
  return picked.map((w) => w[0]).join("").toUpperCase();
};
